import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '@shared/api/http'
import { useSession } from '@shared/lib/auth/session-store'
import { StaffMeResponseSchema } from '@features/auth/api/auth.contract'

async function getCurrentStaff() {
  const data = await apiFetch<unknown>('/admin/auth/me')
  return StaffMeResponseSchema.parse(data)
}

export function SessionHydrator() {
  const token = useSession((state) => state.token)
  const setUser = useSession((state) => state.setUser)
  const { data } = useQuery({
    queryKey: ['admin', 'auth', 'me'],
    queryFn: getCurrentStaff,
    enabled: Boolean(token),
  })

  useEffect(() => {
    if (data) {
      setUser(data)
    }
  }, [data, setUser])

  return null
}
